import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { Section, Container, Box, CheckMark, Button } from '@miro-site/core';
import { LazyImageAdapter, Headline, Content } from '@miro-site/components_utils';
import { css } from 'styled-components';
import { theme } from '@miro-site/design-tokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
//#region TestIDS ----
var prefix = 'tab-component';
export var TestIds = {
  tab: prefix + '-tab-',
  tabContent: prefix + '-tab-content-',
  listItemContainer: prefix + '-list-item-',
  contentContainer: prefix + '-content-'
}; //#endregion TestIDS ----
//#region INTERFACES ----

//#endregion INTERFACES ----
//#region STYLES ----
var TabsContainer = styled(Box).withConfig({
  displayName: "TabsComponent__TabsContainer",
  componentId: "sc-1sigqz-0"
})(["display:flex;overflow-x:auto;margin-top:32px;"]);
var Tab = styled(Box).attrs({
  as: 'a',
  href: 'javascript:void(0)'
}).withConfig({
  displayName: "TabsComponent__Tab",
  componentId: "sc-1sigqz-1"
})(["line-height:16px;font-size:14px;font-weight:400;padding:13px 17px;border-radius:24px;margin-right:8px;white-space:nowrap;border:1px solid ", ";&.active{background-color:#f1f3fd;}> p{white-space:nowrap;}"], theme.colors.grey);
var TabContent = styled(Box).attrs({
  $styles: {
    flexDirection: ['column', null]
  }
}).withConfig({
  displayName: "TabsComponent__TabContent",
  componentId: "sc-1sigqz-2"
})(["display:none;opacity:0;margin-top:26px;", " ", " @keyframes fade{from{opacity:0;}to{opacity:1;}}&.active{display:flex;flex:2 1 auto;width:100%;animation:fade 500ms ease 0s forwards;}"], function (_ref) {
  var $isReversed = _ref.$isReversed;
  return $isReversed && css(["flex-direction:row-reverse;"]);
}, theme.mq.small(css(["flex-direction:column;"])));
var MediaContainer = styled(Box).attrs({
  $ml: null,
  $styles: {
    flexBasis: [null, 700],
    width: ['100%', null]
  }
}).withConfig({
  displayName: "TabsComponent__MediaContainer",
  componentId: "sc-1sigqz-3"
})(["flex-shrink:0;flex-grow:0;"]);
var DataContainer = styled(Box).withConfig({
  displayName: "TabsComponent__DataContainer",
  componentId: "sc-1sigqz-4"
})(["padding:30px 30px 30px 40px;width:100%;", " ", ""], function (_ref2) {
  var $isReversed = _ref2.$isReversed;
  return $isReversed && css(["padding-left:16px;padding-right:40px;"]);
}, theme.mq.small(css(["padding:30px 0 0 0;"])));
var ContentTitleContainer = styled(Box).withConfig({
  displayName: "TabsComponent__ContentTitleContainer",
  componentId: "sc-1sigqz-5"
})(["margin-bottom:24px;font-size:18px;"]);
var ContentContainer = styled(Box).withConfig({
  displayName: "TabsComponent__ContentContainer",
  componentId: "sc-1sigqz-6"
})(["opacity:0.7;"]);
var DataListItemContainer = styled(Box).withConfig({
  displayName: "TabsComponent__DataListItemContainer",
  componentId: "sc-1sigqz-7"
})(["display:flex;align-items:flex-start;margin-bottom:16px;"]);
var CheckIconContainer = styled(Box).withConfig({
  displayName: "TabsComponent__CheckIconContainer",
  componentId: "sc-1sigqz-8"
})(["border-radius:50%;margin-right:10px;position:relative;left:-4px;top:-1px;svg{path{fill:", ";width:22px;height:22px;}}"], theme.colors.primaryIndigo);
var CtaContainer = styled(Box).withConfig({
  displayName: "TabsComponent__CtaContainer",
  componentId: "sc-1sigqz-9"
})(["margin-top:24px;margin-left:-20px;"]);
var ClientDescription = styled(Box).attrs({
  $styles: {
    fontWeight: [700, 500],
    fontSize: [14, 14],
    lineHeight: 24,
    letterSpacing: [null, -0.25]
  }
}).withConfig({
  displayName: "TabsComponent__ClientDescription",
  componentId: "sc-1sigqz-10"
})(["white-space:nowrap;flex-grow:0;"]);
var ClientLogoContainer = styled(Box).withConfig({
  displayName: "TabsComponent__ClientLogoContainer",
  componentId: "sc-1sigqz-11"
})(["display:flex;align-items:center;height:40px;margin-top:16px;"]);
var ClientLogo = styled(Box).withConfig({
  displayName: "TabsComponent__ClientLogo",
  componentId: "sc-1sigqz-12"
})(["flex-grow:1;word-break:break-all;margin-right:20px;"]); //#endregion STYLES ----

var TabsComponent = function TabsComponent(_ref3) {
  var headline = _ref3.headline,
      background = _ref3.background,
      layout = _ref3.layout,
      tabs = _ref3.tabs;

  var _useState = useState(0),
      currentActiveTab = _useState[0],
      setActiveTabIndex = _useState[1];

  var containerRef = useRef(null);

  var handleTabClick = function handleTabClick(position) {
    return function () {
      setActiveTabIndex(position);
    };
  };

  return /*#__PURE__*/_jsx(Section, {
    ref: containerRef,
    children: /*#__PURE__*/_jsxs(Container, {
      $styles: {
        backgroundColor: theme.colors[background] || background,
        borderRadius: '8px',
        padding: '30px'
      },
      children: [/*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
        color: headline.color,
        align: "left"
      })), /*#__PURE__*/_jsx(TabsContainer, {
        children: tabs.map(function (tab, i) {
          return /*#__PURE__*/_jsx(Tab, {
            onClick: handleTabClick(i),
            className: i == currentActiveTab ? 'active' : '',
            "data-testid": TestIds.tab + i,
            children: /*#__PURE__*/_jsx(Content, {
              color: "dark",
              html: tab.title,
              size: "tiny"
            })
          }, i);
        })
      }), tabs.map(function (tab, i) {
        var _clients$logos;

        var cta = tab.cta,
            content = tab.content,
            contentTitle = tab.contentTitle,
            image = tab.image,
            clients = tab.clients;
        return /*#__PURE__*/_jsxs(TabContent, {
          $isReversed: layout == 'RIGHT_IMAGE',
          className: i == currentActiveTab ? 'active' : '',
          "data-testid": TestIds.tabContent + i,
          children: [/*#__PURE__*/_jsx(MediaContainer, {
            children: image && /*#__PURE__*/_jsx(LazyImageAdapter, {
              assets: image,
              rootRef: containerRef
            })
          }), /*#__PURE__*/_jsxs(DataContainer, {
            $isReversed: layout == 'RIGHT_IMAGE',
            children: [contentTitle && /*#__PURE__*/_jsx(ContentTitleContainer, {
              children: /*#__PURE__*/_jsx(Content, {
                color: "dark",
                html: tab.contentTitle,
                size: "medium"
              })
            }), tab.listItems && tab.listItems.length ? tab.listItems.map(function (item, listItemIndex) {
              if (item) {
                return /*#__PURE__*/_jsxs(DataListItemContainer, {
                  "data-testid": TestIds.listItemContainer + i + listItemIndex,
                  children: [/*#__PURE__*/_jsx(CheckIconContainer, {
                    children: /*#__PURE__*/_jsx(CheckMark, {})
                  }), /*#__PURE__*/_jsx(Content, {
                    html: item.title,
                    size: "small"
                  })]
                });
              }
            }) : /*#__PURE__*/_jsx(ContentContainer, {
              "data-testid": TestIds.contentContainer + i,
              children: /*#__PURE__*/_jsx(Content, {
                size: "small",
                color: "dark",
                html: content
              })
            }), cta && /*#__PURE__*/_jsx(CtaContainer, {
              children: /*#__PURE__*/_jsx(Button, {
                $styles: {
                  color: theme.colors.primaryBlue
                },
                $withArrow: true,
                $size: "medium",
                href: cta.href,
                children: cta.text
              })
            }), clients && /*#__PURE__*/_jsxs(Box, {
              $mt: ['24px', '56px'],
              children: [/*#__PURE__*/_jsx(ClientDescription, {
                children: /*#__PURE__*/_jsx(Content, {
                  html: clients.description
                })
              }), /*#__PURE__*/_jsx(ClientLogoContainer, {
                children: clients.logos && clients.logos.length && ((_clients$logos = clients.logos) === null || _clients$logos === void 0 ? void 0 : _clients$logos.map(function (logo, index) {
                  if (logo !== null && logo !== void 0 && logo.src) {
                    return /*#__PURE__*/_jsx(ClientLogo, {
                      children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                        assets: logo,
                        rootRef: containerRef
                      })
                    }, index);
                  }
                }))
              })]
            })]
          })]
        }, i);
      })]
    })
  });
};

export default TabsComponent;